__turbopack_context__.v({
  "box": "TeaserClusterHeader-module-scss-module__MJyXPq__box",
  "headerContainer": "TeaserClusterHeader-module-scss-module__MJyXPq__headerContainer",
  "intro": "TeaserClusterHeader-module-scss-module__MJyXPq__intro",
  "native": "TeaserClusterHeader-module-scss-module__MJyXPq__native",
  "overline": "TeaserClusterHeader-module-scss-module__MJyXPq__overline",
  "premium": "TeaserClusterHeader-module-scss-module__MJyXPq__premium",
  "regular": "TeaserClusterHeader-module-scss-module__MJyXPq__regular",
  "smallCluster": "TeaserClusterHeader-module-scss-module__MJyXPq__smallCluster",
  "title": "TeaserClusterHeader-module-scss-module__MJyXPq__title",
});
